import { ClubTheme } from '../classes';

// hacky and maybe not needed
const defaultClub = new ClubTheme({
  clubId: 0,
  clubName: 'Golf',
});

const astburyTest = new ClubTheme({
  clubId: 264,
  clubName: 'Astbury',
  packageLogoPosition: 'Top',
});

const astbury = new ClubTheme({
  clubId: 472,
  clubName: 'Astbury',
  packageLogoPosition: 'Top',
});

const westEssex = new ClubTheme({
  clubId: 211,
  clubName: 'West Essex',
});

const misRiverShoreline = new ClubTheme({
  clubId: 520,
  clubName: 'Missouri River Points Pass',
});

const misRiverDodge = new ClubTheme({
  clubId: 521,
  clubName: 'Missouri River Points Pass',
});

const pebbleCoveTest = new ClubTheme({
  clubId: 269,
  clubName: 'Missouri River Pass Test',
});

const langlandBay = new ClubTheme({
  clubId: 544,
  clubName: 'Langland Bay Golf Club',
});

const theShire = new ClubTheme({
  clubId: 560,
  clubName: 'Bridgedown Collection',
  packageLogoPosition: 'Top',
});

const theShireTest = new ClubTheme({
  clubId: 592,
  clubName: 'Bridgedown Collection',
  packageLogoPosition: 'Top',
});

const themeList = [
  astburyTest,
  defaultClub,
  westEssex,
  astbury,
  misRiverShoreline,
  misRiverDodge,
  pebbleCoveTest,
  langlandBay,
  theShire,
  theShireTest,
];

export { themeList };
